export default "__VITE_ASSET__7bf4245e__"